import { CustomMap } from '@vendor/libs/maps/maps';
import { InfectionFeatures } from '@vendor/libs/maps/features';
import MapUtils from '@vendor/js/map-utils';
import { DrawInfectionInteraction } from '@vendor/libs/maps/interactions';
import { i18n } from '@vendor/libs/lang/lang';
const _InfectionsMapHandler = (function () {
    const card = $('[data-app-apiary_map_card]');
    let infectionFeatures = null;
    let id = null;
    /**
     * Initializes the map and sets up the necessary features and interactions.
     *
     * @function initMap
     * @returns {void}
     */
    const initMap = () => {
        const map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        infectionFeatures = new InfectionFeatures({
            visibilityListed: false,
            visibilityName: 'infections-current',
            relatedName: 'infection-current',
        });
        map.addFeatures('infections', infectionFeatures);
    };
    /**
     * Sets up and adds a draw interaction for creating infections on the map.
     *
     * @returns {void}
     */
    const addDrawInteraction = () => {
        const map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        // add interaction
        const drawInfectionInteraction = new DrawInfectionInteraction();
        map.addInteraction('draw-infection', drawInfectionInteraction);
        drawInfectionInteraction.on('end', function ({ feature }) {
            InfectionsCommonHandler.clearSelections();
            setInfectionLocation(feature);
        });
    };
    const setInfectionLocation = (geo, fit = false, editInfo = true, highlight = true) => {
        const geojson = MapUtils.geojsonFromAny(geo);
        if (!infectionFeatures) {
            return;
        }
        let map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        infectionFeatures.clear();
        let longitude = geojson.geometry.coordinates[0].toFixed(4);
        let latitude = geojson.geometry.coordinates[1].toFixed(4);
        card.html(`${i18n.trans('map.action.infections.position', {
            latitude: latitude,
            longitude: longitude,
        })}<br /><br /> ${editInfo ? i18n.trans('map.action.infections.position-change') : ''}`);
        id = geojson.id ?? null;
        const features = infectionFeatures.fromGeoJSON(geojson);
        for (const feature of features) {
            feature.set('highlighted', highlight);
        }
        const relatedFeatures = infectionFeatures.related.filter((feature) => features
            .map((feature) => feature.getId())
            .includes(feature.get('related_to')));
        for (const feature of relatedFeatures) {
            feature.set('highlighted', highlight);
        }
        const input = $('[name="geojson"]');
        if (input.length) {
            input.val(geojson.toString()).trigger('change');
        }
        if (fit) {
            infectionFeatures.fit({ maxZoom: 16 });
        }
    };
    return {
        // Public functions
        init: function () {
            initMap();
        },
        addDrawInteraction,
        setInfectionLocation,
    };
})();
window.InfectionsMapHandler = _InfectionsMapHandler;
